<!--
 --添加注释
 --author Paul.Yang E-mail:yaboocn@qq.com
 --version 1.0 2017-7-20
 -->
 <template>
</template>
<script>
  import {toRender} from '@/utils/render'
  export default {
    name: 'dialog',
    props: {
      component: [Object, Function],
      text: String,
      html: String,
      dialogProps: Object,
      params: Object,
      dialog: Boolean
    },
    data () {
      let title = ''
      if (this.dialogProps && this.dialogProps.title) {
        title = this.dialogProps.title
      }
      return {visible: true, title, width: '50%'}
    },
    created: function () {
      let text = this.text
      let html = this.html
      if (this.component) {
        let dialog = this.dialog || this.component.dialog
        let components = {'dialog-content': this.component}
        let prop = ''
        if (this.params) {
          prop = Object.entries(this.params).map(([k, v]) => {
            if (k === 'params') {
              let child = Object.entries(v).map(([k2, v2]) => {
                return `"${k2}":"${v2}"`
              }).join(',')
              return `${k}='{${child}}'`
            }
            return `${k}="${v}"`
          }).join(' ')
        }
        if (dialog) {
          toRender(this, `<dialog-content ${prop} ref="content">${text}${html}</dialog-content>`, components)
        } else {
          let dprops = ''
          if (this.dialogProps) {
            dprops = Object.entries(this.dialogProps).map(([k, v]) => {
              if (k === 'title') {
                return
              }
              return `${k}="${v}"`
            }).join(' ')
          }
          toRender(this, `<el-dialog ${dprops} :title="title" :width="width" :visible.sync="visible"><dialog-content ${prop}>${text}${html}</dialog-content></el-dialog>`, components)
        }
      } else {
        let dprops = ''
        if (this.dialogProps) {
          dprops = Object.entries(this.dialogProps).map((k, v) => {
            if (k === 'title') {
              return
            }
            return `${k}="${v}"`
          }).join(' ')
        }
        toRender(this, `<el-dialog ${dprops} :title="title" :width="width" :visible.sync="visible">${text}${html}</el-dialog>`)
      }
    },
    methods: {
      show () {
        if (this.dialog) {
          this.$refs['content'].show()
        }
        this.visible = true
      },
      isVisible () {
        if (this.dialog && this.$children.length > 0) {
          return this.$children[0].isVisible()
        }
        return this.visible
      },
      hide () {
        if (this.dialog) {
          this.$refs['content'].hide()
        }
        this.visible = false
      },
      setTitle (t) {
        this.title = t
      },
      setWidth (s) {
        this.width = s
      }
    }
  }
</script>



// WEBPACK FOOTER //
// dialog.vue?7f319803